import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "custom-slider-holder" }
const _hoisted_2 = {
  key: 0,
  class: "carousel__navigation carousel__navigation-static custom-slider-nav"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "slide-index carousel_pagination-count desktop-body-l"
}
const _hoisted_5 = ["innerHTML"]

import { onBeforeUnmount, onMounted, ref, toRefs, watch } from 'vue';
import { isMobile} from 'mobile-device-detect';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomCarousel',
  props: {
    slides: {},
    previousIconHtml: { default: '' },
    nextIconHtml: { default: '' },
    selectedSlide: { default: 0 },
    parentCustomClass: { default: '' },
    slideCustomClass: { default: '' },
    thumbnailCustomClass: {},
    showPagination: { type: Boolean, default: false },
    navigationActive: { type: Boolean, default: false },
    isThumbnail: { type: Boolean, default: false }
  },
  emits: ['update:currentSlide'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const {
  slides,
  previousIconHtml,
  nextIconHtml,
  selectedSlide,
  parentCustomClass,
  showPagination,
  navigationActive,
  slideCustomClass,
  isThumbnail,
} = toRefs(props);
const emit = __emit;
const currentIndex = ref<number>(0);
const customSlider = ref({} as HTMLElement);
const touchStartX = ref(0);
const touchEndX = ref(0);
const slideWidth = ref(0);

onMounted(() => {
  window.addEventListener('resize', recalculateWidth);
  recalculateWidth();
  if (isMobile) {
    customSlider.value.ontouchstart = onTouchStart;
  } else {
    customSlider.value.onmousedown = onTouchStart;
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', recalculateWidth);
});
const recalculateWidth = () => {
  if (customSlider.value && customSlider.value.children.length > 0) {
    slideWidth.value = parseFloat(
      window.getComputedStyle(customSlider.value.children[0]).width
    );
    if (isThumbnail.value) {
      setTranslateForthumbnail();
    } else {
      setTranslate();
    }
  }
};

const setTranslateForthumbnail = () => {
  const staticSlides = Math.floor(
    customSlider.value.clientWidth / 2 / slideWidth.value
  );
  // Starting edge cases
  if (currentIndex.value < staticSlides) {
    customSlider.value.style.transform = `translateX(0px)`;
  } else if (currentIndex.value + staticSlides + 1 > slides.value.length) {
    //ending edge cases
    customSlider.value.style.transform = `translateX(-${
      (slides.value.length - staticSlides - staticSlides) * slideWidth.value
    }px)`;
  } else {
    // middle carousel
    customSlider.value.style.transform = `translateX(-${
      (currentIndex.value - staticSlides) * slideWidth.value
    }px)`;
  }
};

const setTranslate = () => {
  customSlider.value.style.transform = `translateX(-${
    currentIndex.value * slideWidth.value
  }px)`;
};
const getTranslateXValue = () => {
  return new DOMMatrix(customSlider.value.style.transform).m41;
};
const moveSlide = (direction: number) => {
  if (
    (currentIndex.value === 0 && direction === -1) ||
    (currentIndex.value === slides.value.length - 1 && direction === 1)
  )
    return;
  slideWidth.value = parseFloat(
    window.getComputedStyle(customSlider.value.children[0]).width
  );
  currentIndex.value = currentIndex.value + direction;
  if (isThumbnail.value) {
    setTranslateForthumbnail();
  } else {
    setTranslate();
  }
};
watch(currentIndex, (value) => {
  if (value !== selectedSlide.value) {
    emit('update:currentSlide', value);
  }
});
watch(selectedSlide, (value) => {
  if (value !== currentIndex.value) {
    currentIndex.value = selectedSlide.value;
    recalculateWidth();
  }
});

const onTouchStart = (event) => {
  if (!isMobile) {
    event.preventDefault();
    touchStartX.value = parseFloat(event.clientX);
    customSlider.value.style.transition = 'none';
    document.onmouseup = onTouchEnd;
    document.onmousemove = onTouchMove;
  } else {
    touchStartX.value = parseFloat(event.touches[0].clientX);
    document.ontouchend = onTouchEnd;
    document.ontouchmove = onTouchMove;
  }
};

const onTouchMove = (event) => {
  if (!isMobile) {
    touchEndX.value = parseFloat(event.clientX);
  } else {
    touchEndX.value = parseFloat(event.touches[0].clientX);
  }
  const moveDistance = touchStartX.value - touchEndX.value;
  if (isThumbnail.value && Math.abs(moveDistance) > 20) {
    const staticSlides = Math.floor(
      customSlider.value.clientWidth / 2 / slideWidth.value
    );
    customSlider.value.style.transform = `translateX(-${Math.min(
      Math.abs(getTranslateXValue()) + moveDistance,
      slideWidth.value * (slides.value.length - 2 * staticSlides)
    )}px)`;
  }
};
const onTouchEnd = () => {
  if (
    !isThumbnail.value &&
    touchEndX.value &&
    touchStartX.value - touchEndX.value > 50
  ) {
    moveSlide(1);
  } else if (
    !isThumbnail.value &&
    touchEndX.value &&
    touchEndX.value - touchStartX.value > 50
  ) {
    moveSlide(-1);
  }
  customSlider.value.style.transition = 'transform 0.5s ease-in-out';
  removeEventListeners();
  touchStartX.value = 0;
  touchEndX.value = 0;
};

const removeEventListeners = () => {
  if (isMobile) {
    document.ontouchend = null;
    document.ontouchmove = null;
  } else {
    document.onmouseup = null;
    document.onmousemove = null;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", {
        ref_key: "customSlider",
        ref: customSlider,
        class: _normalizeClass([_unref(parentCustomClass), 'custom-slider'])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slides), (slide, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: _normalizeClass([_unref(slideCustomClass) ? _unref(slideCustomClass) : 'custom-slider-slide'])
          }, [
            _renderSlot(_ctx.$slots, "main-slide", {
              item: slide,
              index: index
            })
          ], 2))
        }), 128))
      ], 2)
    ]),
    (_unref(slides).length > 1 && _unref(navigationActive))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: _normalizeClass([
        'carousel__prev',
        currentIndex.value > 0 ? '' : 'pointer-events-none opacity-50',
      ]),
            "aria-label": "Previous Slide",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (moveSlide(-1)))
          }, [
            _createElementVNode("div", { innerHTML: _unref(previousIconHtml) }, null, 8, _hoisted_3)
          ], 2),
          (_unref(showPagination))
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(currentIndex.value + 1) + " of " + _toDisplayString(_unref(slides).length), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: _normalizeClass([
        'carousel__next',
        currentIndex.value < _unref(slides)?.length - 1
          ? ''
          : 'pointer-events-none opacity-50',
      ]),
            "aria-label": "Next Slide",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (moveSlide(1)))
          }, [
            _createElementVNode("div", { innerHTML: _unref(nextIconHtml) }, null, 8, _hoisted_5)
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})